import { jsx as _jsx } from "react/jsx-runtime";
import { NodeEdgeMapper } from '@iotv/datamodel';
import { useContext, useMemo } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { NestedContextSelector } from '../../common/NestedContextSelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const NestedContextSelectorWidget = () => {
    const [{ applicationData }] = useContext(AppMainViewContext);
    const nem = new NodeEdgeMapper(applicationData);
    const component = useMemo(() => (_jsx(NestedContextSelector, { nodeEdgeMapper: nem, selectedObject: undefined, setSelectedObject: (selectedObject) => {
            // handle context customer selection here
        }, childPaths: {} })), [nem.getContainedItems()]);
    return {
        name: 'NestedContextSelector',
        category: 'common',
        component,
    };
};
